import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/common/android-download-icon.svg")